<ng-container *ngIf="items$ | async as items; else loadingOrError">
  <div class="card mat-elevation-z2">
    <input class="inputUpload" multiple type="file" autocomplete="off" tabindex="-1"
           #inputUpload (change)="onFilesSelect($event)" />
    <ng-container *ngIf="selection.isEmpty(); else itemsSelectedHeader">
      <header class="header">
        <!-- Crumbs -->
        <span class="crumbs">
          <button mat-icon-button [disabled]="currentPath===''" (click)="setStoragePath('')">
            <mat-icon>home</mat-icon>
          </button>
          <ng-container *ngFor="let crumb of currentPath.split('/') as pathArray;
          let i=index; let last=last">
            <mat-icon *ngIf="currentPath!=''" [style.overflow]="'visible'">chevron_right</mat-icon>
            <button mat-button [disabled]="last"
                    (click)="setStoragePath(getCrumbPath(pathArray, i))">{{crumb}}</button>
          </ng-container>
        </span>

        <button mat-icon-button (click)="reload()"><mat-icon>refresh</mat-icon></button>
        <button mat-icon-button (click)="createNewFolder()"><mat-icon>create_new_folder</mat-icon></button>
        <div>
          <button mat-flat-button color="primary" (click)="inputUpload.click()">Upload</button>
        </div>
      </header>
    </ng-container>

    <ng-template #itemsSelectedHeader>
      <header class="header items-selected">
        <button mat-icon-button (click)="selection.clear()"><mat-icon>close</mat-icon></button>
        <span>{{selection.selected.length}} {{selection.selected.length === 1 ? 'item' : 'items'}}</span>
        <button mat-raised-button color="accent"
                [disabled]="selectionIncludesFolder()"
                (click)="storageService.openAllFiles(selection.selected)">Open all files</button>
        <button mat-stroked-button
                (click)="deleteItems(selection.selected)">Delete</button>
      </header>
    </ng-template>

    <div class="content">
      <div class="table-sidebar">
        <div class="table-wrapper" [style.grid-column-end]="selectedFile ? 'span 8' : 'span 12'">
          <table mat-table [dataSource]="items">
            <!-- Checkbox Column -->
            <ng-container matColumnDef="checkbox">
              <th mat-header-cell *matHeaderCellDef class="checkbox-column">
                <mat-checkbox [disabled]="items.length === 0"
                              [checked]="allItemsSelected(items)"
                              [indeterminate]="allItemsIndeterminate(items)"
                              (change)="toggleAllItems($event.checked, items)"></mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let item" class="checkbox-column">
                <mat-checkbox (click)="$event.stopPropagation()"
                              (change)="selection.toggle(item)"
                              [checked]="selection.isSelected(item)"></mat-checkbox>
              </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef> Name </th>
              <td mat-cell class="name-column" *matCellDef="let item">
                <storage-item-icon [type]="item.type" [contentType]="item.contentType"></storage-item-icon>
                <span>{{item.name}}</span>
              </td>
            </ng-container>

            <!-- Size Column -->
            <ng-container matColumnDef="size">
              <th mat-header-cell *matHeaderCellDef> Size </th>
              <td mat-cell *matCellDef="let item">
                {{item.type === 'folder' ? '&mdash;' : item.size | formatBytes}}
              </td>
            </ng-container>

            <!-- Type Column -->
            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef> Type </th>
              <td mat-cell *matCellDef="let item">
                {{item.type === 'folder' ? 'Folder' : item.contentType}}
              </td>
            </ng-container>

            <!-- Last Modified Column -->
            <ng-container matColumnDef="lastModified">
              <th mat-header-cell *matHeaderCellDef> Last Modified </th>
              <td mat-cell *matCellDef="let item">
                {{item.type === 'folder' ? '&mdash;' : item.updated | date}}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
            <tr mat-row (click)="storageItemSelected(item)" [class.selected]="selectedFile == item" *matRowDef="let item; columns: tableColumns;"></tr>
          </table>
        </div>

        <aside class="sidebar" *ngIf="selectedFile" [style.grid-column-end]="'span 4'">
          <storage-file-preview [item]="selectedFile" (close)="selectedFile = undefined"></storage-file-preview>
        </aside>
      </div>

      <div *ngIf="!items.length" anon-file-dropzone class="empty-folder"
           (click)="inputUpload.click()"
           (dropped)="uploadItems($event)" hover-class="hovering">
        <div>No files found</div>
        <div>Drag and drop files to upload</div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loadingOrError>
  <anon-loading-or-error [error]="error"></anon-loading-or-error>
</ng-template>
